<script>
/**
 * お知らせメニューグループ
 *
 * SideMenuGroupsを拡張して自身でお知らせを取得し、MenuItemに展開します
 * お知らせの取得にPlatformAPIを利用するためクライアントIDを必要とします
 * 不要なリクエストを避けるためサイドメニューを開いてからお知らせをロードします
 * PF-APIのレスポンスが十分速いため通常はメニューオープンのアニメーション中にロード完了します
 */
import Announcement         from '../../../../libs/announcement';
import ErrorReporter        from '@istyle-inc/js-error-reporter/vue-error-reporter';
import SideMenuGroup        from '../side-menu-group';
import SideMenuItem         from '../side-menu-item';
import Vue                  from 'vue';
import ItemAnnouncementList from '../side-menu-item/announcement-list';

const MAX_ANNOUNCE_COUNT = 5;

export default {
  name  : 'side-menu-group-announcement',
  mixins: [SideMenuGroup, ErrorReporter],
  data  : function() {
    return {
      activated: false,
      label    : '@cosmeからのお知らせ',
      menuItems: [],
      analytics: { label: 'side_menu_group_announcement' },
    };
  },
  watch: {
    active: function() {
      if (!this.active) {
        return;
      }
      this.activated = true;
    },
    activated: function() {
      this.load();
    },
  },
  methods: {
    load: function() {
      Announcement.load(this.$store.state.platformApi.clientId)
        .then(this.setMenuItems)
        .catch((error) => {
          this.report('Load announcements failed', error);
          this.label = null;
        });
    },
    setMenuItems: function(announcements) {
      const analytics = this.analytics;
      const visibleAnnouncements = announcements.slice(0, MAX_ANNOUNCE_COUNT);
      this.menuItems = visibleAnnouncements.map((announcement) => {
        return Vue.extend({
          name  : 'side-menu-item-announcement',
          mixins: [SideMenuItem],
          data  : function() {
            return {
              label    : announcement.label,
              link     : announcement.link,
              external : announcement.external,
              analytics: analytics,
            };
          },
        });
      });
      this.menuItems.push(ItemAnnouncementList);
    },
  },
};
</script>
